import React, { useEffect, useState } from "react";
import {
  RootContainer,
  Form,
  Banner,
  Container,
  FormContainer,
  Input,
  FilledButton,
  BackText,
  SkipText,
  Divider,
  Title,
  ButtonWrapper,
  GoogleLoginButton,
  SpaceBetweenTopBottom,
  SocialRegisterWrapper,
  TelegramRegisterButton
} from "../Authentication.style";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { useDispatch, useSelector } from "react-redux";
import { useMemo } from "react";
import { openAlert } from "@redux/app/appSlice";
import { Alert } from "@components";
import { useTranslation } from "react-i18next";
import { useGoogleLogin } from "@react-oauth/google";
import { getSignature } from "@utils";
import axios from "axios";
import { IconGoogle,IconTelegram } from "@assets";
import { Spin } from "antd";

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const REFERRAL_ID_KEY = "referral_id";

const Register = () => {
  const { t } = useTranslation();
  const query = useQuery();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [telebot, setTeleBot] = useState("");
  
    useEffect(() => {
    getSettings();
    },[])


  const onFinish = (data) => {
    let payload = {};
    if (data.phone) {
      payload.phone = data.phone;
    }
    if (data.email) {
      payload.email = data.email;
    }
    api
      .preRegister(payload)
      .then(() => {
        setLoading(false);
        setGoogleLoading(false);
        successCallback(data);
      })
      .catch((errorMsg) => {
        setLoading(false);
        setGoogleLoading(false);
        showAlert({
          message: errorMsg,
          isError: true,
        });
      });
  };

  const successCallback = (data) => {
    let referral_id = query.get(REFERRAL_ID_KEY);
    if (referral_id) {
      data.referral_id = referral_id;
    }
    navigate(`/${PUBLIC_ROUTE.CREATE_PASSWORD}`, {
      state: data,
    });
  };

  const skip = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}`);
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.LOGIN}`);
  };

  const goToPromoRegister = () => {
    let referral_id = query.get(REFERRAL_ID_KEY);
    if (referral_id) {
      navigate(`/${PUBLIC_ROUTE.PROMO_REGISTER}?${REFERRAL_ID_KEY}=${referral_id}`)
    } else {
      navigate(`/${PUBLIC_ROUTE.PROMO_REGISTER}`)
    }
  }

  const onGoogleLoginSuccess = (credentialResponse) => {
    setGoogleLoading(true);
    const { name, picture, sub, email } = credentialResponse;
    const signature = getSignature(email, sub);
    const data = {
      email,
      name,
      google_user_id: sub,
      image: picture,
      signature,
    };
    onFinish(data);
  }

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const userInfo = await axios.get(
          'https://www.googleapis.com/oauth2/v3/userinfo',
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );
        onGoogleLoginSuccess(userInfo.data);
      } catch (err) {
        console.error('Failed to fetch user info:', err);
      }
    },
    onError: () => {
      console.error('Login Failed');
    }
  });


  if (isLoggedIn) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} />;
  }

    const getSettings = () => {
    api
      .getSettings()
      .then(({ setting }) => {
       setTeleBot(setting?.tele_otp_username);
  
      })
      .catch((errorMsg) => {
        console.error(errorMsg);
      });
  }     

  return (
    <>
      <RootContainer>
        <Banner />
        <BackText onClick={goBack}>{t("common.back")}</BackText>
        <SkipText onClick={skip}>{t("common.skip")}</SkipText>
        <Container>
          <Title>{t("auth.register")}</Title>
       

          <FormContainer>
             <SocialRegisterWrapper>
          <GoogleLoginButton onClick={() => {
              if (!googleLoading) {
                googleLogin();
              }
            }}>
              {googleLoading && <Spin />}
              <IconGoogle />
              {t("auth.googleRegister")}
            </GoogleLoginButton>
            <TelegramRegisterButton onClick={() => {
          window.open(`https://t.me/${telebot}`)
        }}>
          <IconTelegram />
          {t('auth.telegramRegister')}
        </TelegramRegisterButton>
            </SocialRegisterWrapper>
          <Divider>{t("auth.or")}</Divider>
            <Form layout="vertical" requiredMark={false} onFinish={onFinish}>
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                  {
                    min: 4,
                    max: 45,
                    message: t("auth.registerNameValidate"),
                  },
                ]}
              >
                <Input
                  autoFocus
                  size="large"
                  placeholder={t("auth.registerName")}
                />
              </Form.Item>
              <Form.Item
                name="phone"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                  {
                    pattern: /^0(1|9)\d{7,9}$/,
                    message: t("auth.registerPhoneValidate"),
                  },
                ]}
              >
                <Input type="number" size="large" placeholder={t("auth.registerPhone")} />
              </Form.Item>
              <Form.Item>
                <FilledButton htmlType="submit" loading={loading}>
                  {t("common.continue")}
                </FilledButton>
              </Form.Item>
            </Form>
           
          </FormContainer>
          <SpaceBetweenTopBottom>
           <ButtonWrapper>
            <FilledButton onClick={goToPromoRegister}>
              {t("auth.promoRegister")}
            </FilledButton>
          </ButtonWrapper>
         </SpaceBetweenTopBottom>
        </Container>
      </RootContainer>
      <Alert />
    </>
  );
};

export default Register;
